import { default as GameLoaderBridge } from './connect';
export { GameLoaderBridge };
